module.exports = cornerstoneMath;